import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { billingActions } from "../../../../../../_actions/billing.actions";
import _ from "lodash";
import {
  buildBillingBreakdownUrl,
  transformBillingRows,
} from "../billingUtils";

export default function (range, metricKey) {
  const dispatch = useDispatch();
  const billings = useSelector((state) => state.billing);
  const loading = billings?.loadingBillingsSummary;
  const billingsList = _.get(billings, "billingsSummary.items", []);

  useEffect(() => {
    if (!range?.startDate || !range?.endDate) {
      return;
    }

    const params = {
      startDate: range?.startDate,
      endDate: range?.endDate,
    };

    dispatch(billingActions.getBillingsSummary(params));
  }, [range?.startDate, range?.endDate]);

  const rows = transformBillingRows(billingsList, metricKey).map((row) => ({
    ...row,
    param: buildBillingBreakdownUrl(row.organizationName, range),
  }));
  const totalCount = rows?.length;

  const columns = [
    {
      id: "organizationName",
      label: "Organization Name",
      width: 150,
      clickable: true,
      isSortable: true,
    },
    {
      id: "teams",
      label: "Teams",
      width: 100,
      isSortable: true,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "proactiveSocial",
      label: "Proactive social",
      width: 100,
      isSortable: true,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "socialModeration",
      label: "Social Moderation",
      width: 100,
      isSortable: true,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "unknown",
      label: "Unknown",
      width: 100,
      isSortable: true,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "total",
      label: "Total",
      width: 120,
      isSortable: true,
      align: "right",
      format: (value) => value.toLocaleString("en-US"),
    },
  ];

  return { rows, columns, totalCount, loading };
}
